import styled from "styled-components";

export const AlertStyled = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: calc(100% - 40px);
  height: calc(100% - 40px);
  /* Alert เป็นชั้นบนสุดของ modal ต้องมากกว่า Modals.BodyEmpty (200)
     เพราะหลายที่เรียก AlertControl.show ขณะที่ modal อื่นยังเปิดอยู่ */
  z-index: 250;
  display: flex;
  padding: 20px;
  justify-content: center;
  align-items: center;
  .backdrop {
    position: absolute;
    z-index: -1;
    width: 100%;
    height: 100%;
    background: ${({ theme }) => theme.COLORS.BLACK_2}D6;
  }
  .alert_body {
    border-radius: 16px;
    width: 100%;
    max-width: 350px;
    padding: 18px 12px;
    background: ${({ theme }) => theme.COLORS.WHITE_2};
    .alert_title {
      margin-bottom: 12px;
      text-align: center;
      font-size: ${({ theme }) => theme.FONT.SIZE.S22};
      font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_REGULAR};
      color: ${({ theme }) => theme.COLORS.RED_1};
      white-space: pre-wrap;
    }
    .alert_description {
      text-align: center;
      color: ${({ theme }) => theme.COLORS.PURPLE_1};
      font-size: ${({ theme }) => theme.FONT.SIZE.S16};
      font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_LIGHT};
      white-space: pre-wrap;
    }
    .alert_action_row {
      margin-top: 30px;
      display: flex;
      column-gap: 16px;
      .alert_action_col {
        flex: 1;
      }
    }
  }
`;
